
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bkGU6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3K1px = parcelRequire("3K1px");

parcelRequire("b1pD4");
var $3ACqI = parcelRequire("3ACqI");


var $6O2BV = parcelRequire("6O2BV");


var $58PBI = parcelRequire("58PBI");


var $7EX8o = parcelRequire("7EX8o");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $h5LRe = parcelRequire("h5LRe");


var $34NZw = parcelRequire("34NZw");


var $5KL6w = parcelRequire("5KL6w");

parcelRequire("8pBIa");
var $6Evf5 = parcelRequire("6Evf5");

parcelRequire("4Yv1J");
var $f5aR2 = parcelRequire("f5aR2");


var $crTA1 = parcelRequire("crTA1");


var $4H46k = parcelRequire("4H46k");


var $9pOEz = parcelRequire("9pOEz");

const $4274e8601e75ee5a$export$d4592052ec650378 = ({ spaceKey: spaceKey, contentId: contentId, isPage: isPage, isMobile: isMobile, isEmbeddedConfluence: isEmbeddedConfluence })=>{
    const pageType = isPage ? 'page' : 'blogpost';
    let component;
    if (isEmbeddedConfluence) component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    }));
    else if (isMobile) component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyMobileWebContainer), null));
    else component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
        value: (0, $3K1px.getEditorPreloader)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5KL6w.PresenterModeContextProvider), {
        contentId: contentId,
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5LRe.ViewPageLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Evf5.default), {
        pageType: pageType
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crTA1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageRouteComponent",
        skip: isMobile
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: isPage
    }));
};
module.exports["ViewPageRouteComponent"] = $4274e8601e75ee5a$export$d4592052ec650378;

});

parcelRegister("b1pD4", function(module, exports) {
$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("3ACqI")).CommentsSectionLoader);

var $3ACqI = parcelRequire("3ACqI");


});

parcelRegister("3ACqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $hnvzE = parcelRequire("hnvzE");


var $7d2Nc = parcelRequire("7d2Nc");


var $eHtji = parcelRequire("eHtji");


var $jmjWc = parcelRequire("jmjWc");


var $deTj5 = parcelRequire("deTj5");


var $6Hogt = parcelRequire("6Hogt");


var $2YUV8 = parcelRequire("2YUV8");


var $dDqLo = parcelRequire("dDqLo");


var $3Am3T = parcelRequire("3Am3T");


var $bQm3c = parcelRequire("bQm3c");


var $dkkKv = parcelRequire("dkkKv");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


const $bab3bd054370fc67$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ3wU",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("6SQsY"))
});

const $bab3bd054370fc67$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y3qpe",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("6SQsY"))
});
const $bab3bd054370fc67$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    const { refetch: refetchActiveInlineComments } = (0, $7Oxky.useActiveInlineCommentsQuery)({
        pageId: contentId,
        markerRefList: []
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eHtji.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }))));
};
$bab3bd054370fc67$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["CommentsSectionLoader"] = $bab3bd054370fc67$export$2fa3aacacd7711f1;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("6Hogt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["isBMPageLoad"] = $2a47a9fc48674e91$export$9dede01b6f349441;
module.exports["hasBMPageLoadStarted"] = $2a47a9fc48674e91$export$cb339d0cd5cc821c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("2YUV8", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");

const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $eSUdr.default)`query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $xQxzY.useQuery)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId
    });
    // If the feature flag is not enabled, we should always allow nested comments
    if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return true;
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};
module.exports["useAllowNestedComments"] = $d2978a0663607f28$export$3044701888c6e050;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed && (0, $9wGTI.fg)('confluence_comment_donot_use_cache') ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $eg9xl.ActiveCommentsQuery), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        pageMode,
        currentUserId,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("htsj6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, options);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<2907f65b81f9f12ac8d707a3a8f4b524>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("aqBZ0", function(module, exports) {
const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;

});

parcelRegister("aPT9H", function(module, exports) {
/**
 * @graphql cc
 */ 
var $j1Ss3 = parcelRequire("j1Ss3");


var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("7Oxky", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $eSUdr.default)`query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;
module.exports["useActiveInlineCommentsQuery"] = $9d95853344936385$export$6ddede7674b6d70f;

});

parcelRegister("6SQsY", function(module, exports) {

let $50307bee40a9ce9d$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $50307bee40a9ce9d$var$load("8VT23"),
    $50307bee40a9ce9d$var$load("in5DP"),
    $50307bee40a9ce9d$var$load("dpY3T"),
    $50307bee40a9ce9d$var$load("918Xb"),
    $50307bee40a9ce9d$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("1YwJ8"), 5)),
    $50307bee40a9ce9d$var$load("i0ttV"),
    $50307bee40a9ce9d$var$load("e4Jl9"),
    $50307bee40a9ce9d$var$load("gLGsg"),
    $50307bee40a9ce9d$var$load("4oJQT"),
    $50307bee40a9ce9d$var$load("ffEVr"),
    $50307bee40a9ce9d$var$load("ba8JR"),
    $50307bee40a9ce9d$var$load("2zqtv")
]).then(()=>parcelRequire('kXPQu'));

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("3YlWu"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("3YlWu", function(module, exports) {

let $2e47ff02d210dc59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e47ff02d210dc59$var$load("h3ABO"),
    $2e47ff02d210dc59$var$load("7HyY8"),
    $2e47ff02d210dc59$var$load("2YffH"),
    $2e47ff02d210dc59$var$load("b99Vc"),
    $2e47ff02d210dc59$var$load("2PePB"),
    $2e47ff02d210dc59$var$load("gNLJV"),
    $2e47ff02d210dc59$var$load("c83ag"),
    $2e47ff02d210dc59$var$load("2F69B"),
    $2e47ff02d210dc59$var$load("5Fr9q"),
    $2e47ff02d210dc59$var$load("fJtJG"),
    $2e47ff02d210dc59$var$load("d63le"),
    $2e47ff02d210dc59$var$load("l8GL7"),
    $2e47ff02d210dc59$var$load("lkOIY"),
    $2e47ff02d210dc59$var$load("clQc9"),
    $2e47ff02d210dc59$var$load("8PPsf"),
    $2e47ff02d210dc59$var$load("jbxHq"),
    $2e47ff02d210dc59$var$load("8YSo7"),
    $2e47ff02d210dc59$var$load("k6h1Q"),
    $2e47ff02d210dc59$var$load("lz6Bt"),
    $2e47ff02d210dc59$var$load("76iIp"),
    $2e47ff02d210dc59$var$load("az9CK"),
    $2e47ff02d210dc59$var$load("ht6hk"),
    $2e47ff02d210dc59$var$load("9ijrN"),
    $2e47ff02d210dc59$var$load("3w411"),
    $2e47ff02d210dc59$var$load("eY3St"),
    $2e47ff02d210dc59$var$load("bkd4T"),
    $2e47ff02d210dc59$var$load("hv4mn"),
    $2e47ff02d210dc59$var$load("6wr18"),
    $2e47ff02d210dc59$var$load("kjZZD"),
    $2e47ff02d210dc59$var$load("Wowvf"),
    $2e47ff02d210dc59$var$load("cyGuT"),
    $2e47ff02d210dc59$var$load("dRpV3"),
    $2e47ff02d210dc59$var$load("ffEVr"),
    $2e47ff02d210dc59$var$load("daAWB"),
    $2e47ff02d210dc59$var$load("hxjWM"),
    $2e47ff02d210dc59$var$load("avVwC"),
    $2e47ff02d210dc59$var$load("9fieX"),
    $2e47ff02d210dc59$var$load("fZt2F"),
    $2e47ff02d210dc59$var$load("6u1hm"),
    $2e47ff02d210dc59$var$load("fL5gS"),
    $2e47ff02d210dc59$var$load("9V45O"),
    $2e47ff02d210dc59$var$load("3yj56"),
    $2e47ff02d210dc59$var$load("6mG00"),
    $2e47ff02d210dc59$var$load("eTYdV"),
    $2e47ff02d210dc59$var$load("jryxA"),
    $2e47ff02d210dc59$var$load("dWZbK"),
    $2e47ff02d210dc59$var$load("iqKwT"),
    $2e47ff02d210dc59$var$load("kULV9"),
    $2e47ff02d210dc59$var$load("jEmf3"),
    $2e47ff02d210dc59$var$load("19QIS"),
    $2e47ff02d210dc59$var$load("kUbUu"),
    $2e47ff02d210dc59$var$load("kBC8C"),
    $2e47ff02d210dc59$var$load("hioRe"),
    $2e47ff02d210dc59$var$load("jTort"),
    $2e47ff02d210dc59$var$load("1Ldmy"),
    $2e47ff02d210dc59$var$load("7aOpi"),
    $2e47ff02d210dc59$var$load("8H48c"),
    $2e47ff02d210dc59$var$load("gq5DC"),
    $2e47ff02d210dc59$var$load("kWSPH"),
    $2e47ff02d210dc59$var$load("hhss7"),
    $2e47ff02d210dc59$var$load("d4vRh"),
    $2e47ff02d210dc59$var$load("31Cn4"),
    $2e47ff02d210dc59$var$load("7EorR"),
    $2e47ff02d210dc59$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("7EX8o", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $1c44eab82f88f298$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NLJVG",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("1PNZJ"))).EmbeddedViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["EmbeddedViewPageLoader"] = $1c44eab82f88f298$export$3717da370a5be6bc;

});

parcelRegister("1PNZJ", function(module, exports) {

let $156155be18400c80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $156155be18400c80$var$load("jCMGS"),
    $156155be18400c80$var$load("fBVt2"),
    $156155be18400c80$var$load("liFbs"),
    $156155be18400c80$var$load("c6wqb"),
    $156155be18400c80$var$load("7u5Uq"),
    $156155be18400c80$var$load("5XYzR"),
    $156155be18400c80$var$load("dlm6q"),
    $156155be18400c80$var$load("i7xTD"),
    $156155be18400c80$var$load("7j65o"),
    $156155be18400c80$var$load("9ZkgN"),
    $156155be18400c80$var$load("2mt3f"),
    $156155be18400c80$var$load("lnnYm"),
    $156155be18400c80$var$load("bEaYR"),
    $156155be18400c80$var$load("4wv8d"),
    $156155be18400c80$var$load("5fCHG"),
    $156155be18400c80$var$load("2F69B"),
    $156155be18400c80$var$load("5GE15"),
    $156155be18400c80$var$load("3uovx"),
    $156155be18400c80$var$load("a5UQo"),
    $156155be18400c80$var$load("e4Jl9"),
    $156155be18400c80$var$load("in5DP"),
    $156155be18400c80$var$load("gLGsg"),
    $156155be18400c80$var$load("dpY3T"),
    $156155be18400c80$var$load("b6EsR"),
    $156155be18400c80$var$load("918Xb"),
    $156155be18400c80$var$load("8tLTz"),
    $156155be18400c80$var$load("dTsOE"),
    $156155be18400c80$var$load("ba8JR"),
    $156155be18400c80$var$load("3yj56"),
    $156155be18400c80$var$load("6mG00"),
    $156155be18400c80$var$load("kULV9"),
    $156155be18400c80$var$load("6wr18"),
    $156155be18400c80$var$load("5UCxV"),
    $156155be18400c80$var$load("4yXIN"),
    $156155be18400c80$var$load("jyLCl"),
    $156155be18400c80$var$load("8VT23"),
    $156155be18400c80$var$load("cUIaj"),
    $156155be18400c80$var$load("jwWp5"),
    $156155be18400c80$var$load("Wowvf"),
    $156155be18400c80$var$load("cyGuT"),
    $156155be18400c80$var$load("ffEVr"),
    $156155be18400c80$var$load("iqKwT"),
    $156155be18400c80$var$load("kUbUu"),
    $156155be18400c80$var$load("gq5DC"),
    $156155be18400c80$var$load("kWSPH"),
    $156155be18400c80$var$load("hhss7"),
    $156155be18400c80$var$load("7EorR"),
    $156155be18400c80$var$load("1gUNx"),
    $156155be18400c80$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("h5LRe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $44ffefac2a9fdc13$export$2bcf56c785109ac9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z8NN7",
    name: "ViewPageLoader",
    loader: async ()=>(await (parcelRequire("1J0AO"))).ViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["ViewPageLoader"] = $44ffefac2a9fdc13$export$2bcf56c785109ac9;

});

parcelRegister("1J0AO", function(module, exports) {

let $141a741be24fedc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $141a741be24fedc4$var$load("h3ABO"),
    $141a741be24fedc4$var$load("jTaSF"),
    $141a741be24fedc4$var$load("jCMGS"),
    $141a741be24fedc4$var$load("c6wqb"),
    $141a741be24fedc4$var$load("5XYzR"),
    $141a741be24fedc4$var$load("1sSgo"),
    $141a741be24fedc4$var$load("6tsCm"),
    $141a741be24fedc4$var$load("7j65o"),
    $141a741be24fedc4$var$load("bEaYR"),
    $141a741be24fedc4$var$load("2F69B"),
    $141a741be24fedc4$var$load("5GE15"),
    $141a741be24fedc4$var$load("3uovx"),
    $141a741be24fedc4$var$load("e4Jl9"),
    $141a741be24fedc4$var$load("in5DP"),
    $141a741be24fedc4$var$load("gLGsg"),
    $141a741be24fedc4$var$load("dpY3T"),
    $141a741be24fedc4$var$load("5Fr9q"),
    $141a741be24fedc4$var$load("fJtJG"),
    $141a741be24fedc4$var$load("lkOIY"),
    $141a741be24fedc4$var$load("clQc9"),
    $141a741be24fedc4$var$load("8PPsf"),
    $141a741be24fedc4$var$load("76iIp"),
    $141a741be24fedc4$var$load("az9CK"),
    $141a741be24fedc4$var$load("eY3St"),
    $141a741be24fedc4$var$load("bkd4T"),
    $141a741be24fedc4$var$load("daAWB"),
    $141a741be24fedc4$var$load("hxjWM"),
    $141a741be24fedc4$var$load("avVwC"),
    $141a741be24fedc4$var$load("9fieX"),
    $141a741be24fedc4$var$load("7HyY8"),
    $141a741be24fedc4$var$load("6u1hm"),
    $141a741be24fedc4$var$load("ba8JR"),
    $141a741be24fedc4$var$load("jryxA"),
    $141a741be24fedc4$var$load("dWZbK"),
    $141a741be24fedc4$var$load("19QIS"),
    $141a741be24fedc4$var$load("jTort"),
    $141a741be24fedc4$var$load("1Ldmy"),
    $141a741be24fedc4$var$load("d4vRh"),
    $141a741be24fedc4$var$load("31Cn4"),
    $141a741be24fedc4$var$load("3yj56"),
    $141a741be24fedc4$var$load("6mG00"),
    $141a741be24fedc4$var$load("kULV9"),
    $141a741be24fedc4$var$load("6wr18"),
    $141a741be24fedc4$var$load("5UCxV"),
    $141a741be24fedc4$var$load("4yXIN"),
    $141a741be24fedc4$var$load("jyLCl"),
    $141a741be24fedc4$var$load("8VT23"),
    $141a741be24fedc4$var$load("cUIaj"),
    $141a741be24fedc4$var$load("jwWp5"),
    $141a741be24fedc4$var$load("Wowvf"),
    $141a741be24fedc4$var$load("cyGuT"),
    $141a741be24fedc4$var$load("ffEVr"),
    $141a741be24fedc4$var$load("iqKwT"),
    $141a741be24fedc4$var$load("kUbUu"),
    $141a741be24fedc4$var$load("gq5DC"),
    $141a741be24fedc4$var$load("kWSPH"),
    $141a741be24fedc4$var$load("hhss7"),
    $141a741be24fedc4$var$load("1gUNx"),
    $141a741be24fedc4$var$load("7EorR"),
    $141a741be24fedc4$var$load("lxU5p")
]).then(()=>parcelRequire('bSweK'));

});

parcelRegister("34NZw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("evlHl"));
        return PageShownPublicLinksEvent;
    }
});
module.exports["PageShownPublicLinksEventLoader"] = $d52b69b4dbbb4bb4$export$e6747c633274762a;

});

parcelRegister("evlHl", function(module, exports) {

let $a8f4cabc2ec9642a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8f4cabc2ec9642a$var$load("63zHi").then(()=>parcelRequire('jvel0'));

});

parcelRegister("8pBIa", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6Evf5")).default);

var $6Evf5 = parcelRequire("6Evf5");


});

parcelRegister("6Evf5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $hl1Kw = parcelRequire("hl1Kw");


var $3GP6F = parcelRequire("3GP6F");


var $gTyTP = parcelRequire("gTyTP");


var $aeLio = parcelRequire("aeLio");

parcelRequire("hAOSI");
var $9LzHv = parcelRequire("9LzHv");


var $iAoZQ = parcelRequire("iAoZQ");

const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source = 'viewPageScreen' })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const commentLink = (0, $aeLio.useGetCommentLinkType)();
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $iAoZQ.SendTrackViewPageEventQuery), {
        variables: {
            contentId: contentId
        }
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {},
            livePageReleasePhase: livePageReleasePhase,
            ...commentLink && {
                commentLink: commentLink
            }
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;
module.exports["default"] = $4d7eb68e35a8590f$export$2e2bcd8739ae039;

});

parcelRegister("3GP6F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $QU6QS.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $42omo.useState)(queryParamsFeatureCodes);
    (0, $42omo.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("hAOSI", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("9LzHv")).default);

var $9LzHv = parcelRequire("9LzHv");


});

parcelRegister("9LzHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $1DWH0 = parcelRequire("1DWH0");

const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes = {}, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $42omo.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent({
            ...props,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("iAoZQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $d87efa95de2d7c4b$export$891b2cd76733e577 = (0, $eSUdr.default)`query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id history{createdDate lastUpdated{when}}metadata{frontend{fabricEditorSupported fabricEditorEligibility}}space{id}status}}}`;
module.exports["SendTrackViewPageEventQuery"] = $d87efa95de2d7c4b$export$891b2cd76733e577;

});

parcelRegister("4Yv1J", function(module, exports) {
$parcel$export(module.exports, "ContentExtensionsProvider", () => (parcelRequire("f5aR2")).ContentExtensionsProvider);

var $f5aR2 = parcelRequire("f5aR2");


});

parcelRegister("f5aR2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k77lQ = parcelRequire("k77lQ");


var $69aHU = parcelRequire("69aHU");


var $hFueH = parcelRequire("hFueH");


var $hMRhJ = parcelRequire("hMRhJ");


const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("gY2se"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $k77lQ.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $hFueH.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);
module.exports["ContentExtensionsProvider"] = $cc34c55db5a1bcbb$export$2a88d3b468decd4a;

});

parcelRegister("gY2se", function(module, exports) {

let $c5a42755014c640b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5a42755014c640b$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});

parcelRegister("9pOEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9jl6v = parcelRequire("9jl6v");

const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};
module.exports["CommentContextWrapper"] = $1adfb96e71037064$export$1d04f0e8aa57d594;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;
module.exports["default"] = $830764d8fffe9f5a$export$2e2bcd8739ae039;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$ed215fd77db898ec(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToScriptTags"] = $372ebd682f0fb003$export$ed215fd77db898ec;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("9sGCn", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataContentFragment on Content{id subType status}`
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypeContentFragment on Content{id subType}`
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypePageTreeFragment on PTPage{id subType}`
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypeSearchFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/editor-features/src/utils/getCachedPageTitle.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c65934a9e331ff8701130392e383f058>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jMyy4 = parcelRequire("jMyy4");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch (e) {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<edc256fe5c5e6d649d0fd080ebecc4d6>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("7zIsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("lpxTx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ac0bfd36ecfdf97$export$7e83667ababb3077 = (0, $eSUdr.default)`query ContentBlogUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false){content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentBlogUnifiedQuery"] = $4ac0bfd36ecfdf97$export$7e83667ababb3077;

});

parcelRegister("61vTv", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7b6381fcd1b9e458$export$16dddce791a11901 = (0, $eSUdr.default)`query ContentUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "emoji-title-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentUnifiedQuery"] = $7b6381fcd1b9e458$export$16dddce791a11901;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKey = contentType === 'database' ? 'confluence-databases' : 'confluence-whiteboards';
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKey);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});

parcelRegister("6UBEn", function(module, exports) {
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerStylesT26Shape = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$barStylesT26Shape = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_v564calv",
                (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
            ])
        })
    });
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("eUDtA", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5nBzc = parcelRequire("5nBzc");


var $1DWH0 = parcelRequire("1DWH0");


var $hFf4D = parcelRequire("hFf4D");


var $aLypr = parcelRequire("aLypr");

function $fb06ceb36ba8e92b$var$_defineProperty(e, r, t) {
    return (r = $fb06ceb36ba8e92b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb06ceb36ba8e92b$var$_toPropertyKey(t) {
    var i = $fb06ceb36ba8e92b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb06ceb36ba8e92b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE = 'default';
const $fb06ceb36ba8e92b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $fb06ceb36ba8e92b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $fb06ceb36ba8e92b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $fb06ceb36ba8e92b$var$StatusInternal extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap[color] || $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $gMc0m.default)([
                $fb06ceb36ba8e92b$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            maxWidth: $fb06ceb36ba8e92b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "hoverStartTime", 0);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$fb06ceb36ba8e92b$var$_defineProperty($fb06ceb36ba8e92b$var$StatusInternal, "displayName", 'StatusInternal');
const $fb06ceb36ba8e92b$export$96e9906d6d93a972 = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($fb06ceb36ba8e92b$var$StatusInternal);
module.exports["Status"] = $fb06ceb36ba8e92b$export$96e9906d6d93a972;

});

parcelRegister("hFf4D", function(module, exports) {
const $d7337cb21e4187c0$export$d821aa4c8afb384e = 'fabric-elements';
const $d7337cb21e4187c0$var$packageName = "platform-pkg";
const $d7337cb21e4187c0$var$packageVersion = "0.0.0-use.local";
const $d7337cb21e4187c0$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $d7337cb21e4187c0$var$packageName;
        statusPayload.attributes.packageVersion = $d7337cb21e4187c0$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($d7337cb21e4187c0$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $d7337cb21e4187c0$export$aa98853957f9f5aa;

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("cQMhV", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("9h6tL")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("7aW37")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("9f7tI")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("5Eiz2")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("9jJiA")).PanelNoteIcon);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("c0czl")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $9h6tL = parcelRequire("9h6tL");


var $7aW37 = parcelRequire("7aW37");


var $9f7tI = parcelRequire("9f7tI");


var $5Eiz2 = parcelRequire("5Eiz2");


var $9jJiA = parcelRequire("9jJiA");




var $c0czl = parcelRequire("c0czl");


const $37f04d4596614e71$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("6Dg06")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $37f04d4596614e71$export$84f497075f5b07be;

});

parcelRegister("9h6tL", function(module, exports) {
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $4e1d4745b1e8289e$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $4e1d4745b1e8289e$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $4e1d4745b1e8289e$export$2187dc2d495c3efc = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($4e1d4745b1e8289e$var$PanelInfoGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelInfoIcon"] = $4e1d4745b1e8289e$export$2187dc2d495c3efc;

});

parcelRegister("7aW37", function(module, exports) {
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c82a733b017451e7$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $c82a733b017451e7$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $c82a733b017451e7$export$246c5468186717b7 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($c82a733b017451e7$var$PanelWarningGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelWarningIcon"] = $c82a733b017451e7$export$246c5468186717b7;

});

parcelRegister("9f7tI", function(module, exports) {
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2c603864430226d2$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $2c603864430226d2$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $2c603864430226d2$export$76fa6c311f4e2871 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($2c603864430226d2$var$PanelErrorGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelErrorIcon"] = $2c603864430226d2$export$76fa6c311f4e2871;

});

parcelRegister("5Eiz2", function(module, exports) {
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $12304797f5f70131$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $12304797f5f70131$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $12304797f5f70131$export$a5a5162e21242c3c = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($12304797f5f70131$var$PanelSuccessGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelSuccessIcon"] = $12304797f5f70131$export$a5a5162e21242c3c;

});

parcelRegister("9jJiA", function(module, exports) {
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0eeb07e0bc008878$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $0eeb07e0bc008878$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $0eeb07e0bc008878$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($0eeb07e0bc008878$var$PanelNoteGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelNoteIcon"] = $0eeb07e0bc008878$export$d4f894f0c3f0db6;

});

parcelRegister("c0czl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

function $3ae2a3e708a69581$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae2a3e708a69581$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $3ae2a3e708a69581$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3ae2a3e708a69581$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $3ae2a3e708a69581$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3ae2a3e708a69581$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $3ae2a3e708a69581$var$getBackground(selectedColor, disabled)
        },
        css: $3ae2a3e708a69581$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $3ae2a3e708a69581$export$76b0278e018f8601;

});

parcelRegister("6Dg06", function(module, exports) {

let $4d42cbffca8d36da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d42cbffca8d36da$var$load("3yj56"),
    $4d42cbffca8d36da$var$load("6mG00"),
    $4d42cbffca8d36da$var$load("7Vmxp")
]).then(()=>parcelRequire('aJWwp'));

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("2ixko", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ac71d7218c06efe$var$_react = $1ac71d7218c06efe$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $1ac71d7218c06efe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac71d7218c06efe$var$Executable16Icon = (props)=>/*#__PURE__*/ $1ac71d7218c06efe$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$1ac71d7218c06efe$var$Executable16Icon.displayName = 'Executable16Icon';
var $1ac71d7218c06efe$var$_default = module.exports.default = $1ac71d7218c06efe$var$Executable16Icon;

});

parcelRegister("4dLYc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $312d962237f997a8$var$_react = $312d962237f997a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $312d962237f997a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $312d962237f997a8$var$Executable24Icon = (props)=>/*#__PURE__*/ $312d962237f997a8$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$312d962237f997a8$var$Executable24Icon.displayName = 'Executable24Icon';
var $312d962237f997a8$var$_default = module.exports.default = $312d962237f997a8$var$Executable24Icon;

});

parcelRegister("d5BUD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $987926a28539ecdc$var$_react = $987926a28539ecdc$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $987926a28539ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $987926a28539ecdc$var$Gif16Icon = (props)=>/*#__PURE__*/ $987926a28539ecdc$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$987926a28539ecdc$var$Gif16Icon.displayName = 'Gif16Icon';
var $987926a28539ecdc$var$_default = module.exports.default = $987926a28539ecdc$var$Gif16Icon;

});

parcelRegister("b4DX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $80ff0f2ee8339e7f$var$_react = $80ff0f2ee8339e7f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $80ff0f2ee8339e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80ff0f2ee8339e7f$var$Gif24Icon = (props)=>/*#__PURE__*/ $80ff0f2ee8339e7f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$80ff0f2ee8339e7f$var$Gif24Icon.displayName = 'Gif24Icon';
var $80ff0f2ee8339e7f$var$_default = module.exports.default = $80ff0f2ee8339e7f$var$Gif24Icon;

});

parcelRegister("4rkAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $33b9a76c1d425a4b$var$_react = $33b9a76c1d425a4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $33b9a76c1d425a4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b9a76c1d425a4b$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $33b9a76c1d425a4b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$33b9a76c1d425a4b$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $33b9a76c1d425a4b$var$_default = module.exports.default = $33b9a76c1d425a4b$var$GoogleDoc16Icon;

});

parcelRegister("5W6v1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $45276929af089f1e$var$_react = $45276929af089f1e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $45276929af089f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45276929af089f1e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $45276929af089f1e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$45276929af089f1e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $45276929af089f1e$var$_default = module.exports.default = $45276929af089f1e$var$GoogleDoc24Icon;

});

parcelRegister("jDMpf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4c73548be2d77b2$var$_react = $e4c73548be2d77b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e4c73548be2d77b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4c73548be2d77b2$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $e4c73548be2d77b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e4c73548be2d77b2$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $e4c73548be2d77b2$var$_default = module.exports.default = $e4c73548be2d77b2$var$GoogleForm16Icon;

});

parcelRegister("av4P2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a508a3974c868b6$var$_react = $7a508a3974c868b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $7a508a3974c868b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a508a3974c868b6$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $7a508a3974c868b6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7a508a3974c868b6$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $7a508a3974c868b6$var$_default = module.exports.default = $7a508a3974c868b6$var$GoogleForm24Icon;

});

parcelRegister("l59oX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f5915b8e34e2cce4$var$_react = $f5915b8e34e2cce4$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f5915b8e34e2cce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5915b8e34e2cce4$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f5915b8e34e2cce4$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f5915b8e34e2cce4$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f5915b8e34e2cce4$var$_default = module.exports.default = $f5915b8e34e2cce4$var$GoogleSheet16Icon;

});

parcelRegister("giYeH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bded0d6c49d90549$var$_react = $bded0d6c49d90549$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $bded0d6c49d90549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bded0d6c49d90549$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $bded0d6c49d90549$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bded0d6c49d90549$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $bded0d6c49d90549$var$_default = module.exports.default = $bded0d6c49d90549$var$GoogleSheet24Icon;

});

parcelRegister("jOGxt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6d3af3126d12bf0$var$_react = $e6d3af3126d12bf0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6d3af3126d12bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6d3af3126d12bf0$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $e6d3af3126d12bf0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6d3af3126d12bf0$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $e6d3af3126d12bf0$var$_default = module.exports.default = $e6d3af3126d12bf0$var$GoogleSlide16Icon;

});

parcelRegister("eWLPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ae1b9556e1933b44$var$_react = $ae1b9556e1933b44$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $ae1b9556e1933b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae1b9556e1933b44$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $ae1b9556e1933b44$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ae1b9556e1933b44$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $ae1b9556e1933b44$var$_default = module.exports.default = $ae1b9556e1933b44$var$GoogleSlide24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("9W0IA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73ba16739a647a26$var$_react = $73ba16739a647a26$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $73ba16739a647a26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73ba16739a647a26$var$Sketch16Icon = (props)=>/*#__PURE__*/ $73ba16739a647a26$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$73ba16739a647a26$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $73ba16739a647a26$var$_default = module.exports.default = $73ba16739a647a26$var$Sketch16Icon;

});

parcelRegister("9AnKp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6fa9e5979f68da4f$var$_react = $6fa9e5979f68da4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6fa9e5979f68da4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fa9e5979f68da4f$var$Sketch24Icon = (props)=>/*#__PURE__*/ $6fa9e5979f68da4f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6fa9e5979f68da4f$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $6fa9e5979f68da4f$var$_default = module.exports.default = $6fa9e5979f68da4f$var$Sketch24Icon;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * Legacy hidden input styles with nested sibling selectors.
    * Used when the `platform-checkbox-atomic-styles` feature gate is disabled.
    * Using `cssMap` to avoid a Compiled bug with the transformed styles.
    * It was using a CSS variable for the outline template string,
    * which broke because of the use of a sibling selector.
    *
    * Related to: https://github.com/atlassian-labs/compiled/pull/1795
    */ 
const $1f9fb6b4b3bc4020$var$checkboxStylesLegacy = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isChecked : undefined,
        isIndeterminate: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isIndeterminate : undefined,
        isInvalid: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isInvalid : undefined,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    (0, $dh538.fg)('platform-checkbox-atomic-styles') && $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    !(0, $dh538.fg)('platform-checkbox-atomic-styles') && $1f9fb6b4b3bc4020$var$checkboxStylesLegacy.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
}; /**
    * Legacy SVG styles.
    * Used when the `platform-checkbox-atomic-styles` feature gate is disabled.
    */ 
const $71feb0a29953fded$var$svgStylesLegacy = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    if ((0, $dh538.fg)('platform-checkbox-atomic-styles')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
     // Legacy rendering with inline style props for CSS variable consumption
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null; /**
                                     * Legacy label styles with --local-* CSS custom properties.
                                     * These are consumed by the nested sibling selectors in checkbox.tsx.
                                     */ 
const $edf27753e59bf881$var$legacyBaseStyles = null;
const $edf27753e59bf881$var$legacyTextLabelLayoutStyles = null;
const $edf27753e59bf881$var$legacyDisabledStyles = null;
const $edf27753e59bf881$var$legacyLabelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    if ((0, $dh538.fg)('platform-checkbox-atomic-styles')) return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("hpNab", function(module, exports) {

var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $dh538 = parcelRequire("dh538");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $8C5kA = parcelRequire("8C5kA");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("8DMug", function(module, exports) {

var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $g9Srd = parcelRequire("g9Srd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7a0922b43eeb26f0$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const exiting = (0, $g9Srd.useExitingPersistence)();
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dclyF.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4c48T.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4c48T.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $7a0922b43eeb26f0$export$2e2bcd8739ae039 = $7a0922b43eeb26f0$var$ShrinkOut;
module.exports["default"] = $7a0922b43eeb26f0$export$2e2bcd8739ae039;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("6wbAc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $852cc06e57df817b$export$83b038038df2eb9 = (0, $eSUdr.default)`query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id settings{routeOverrideEnabled}}}`;
module.exports["SpaceRestrictionCheckQuery"] = $852cc06e57df817b$export$83b038038df2eb9;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("lesF8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

function $0eec8481dd12dbe1$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
}
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

function $c97a308eea576e63$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
}
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("5QzKB"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("5QzKB"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("5QzKB"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("5QzKB", function(module, exports) {

let $441d8a6a3f3441a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $441d8a6a3f3441a0$var$load("8NOg5"),
    $441d8a6a3f3441a0$var$load("2nTw0"),
    $441d8a6a3f3441a0$var$load("jwWp5"),
    $441d8a6a3f3441a0$var$load("76iIp"),
    $441d8a6a3f3441a0$var$load("az9CK"),
    $441d8a6a3f3441a0$var$load("3w411"),
    $441d8a6a3f3441a0$var$load("eY3St"),
    $441d8a6a3f3441a0$var$load("bkd4T"),
    $441d8a6a3f3441a0$var$load("daAWB"),
    $441d8a6a3f3441a0$var$load("hxjWM"),
    $441d8a6a3f3441a0$var$load("gq5DC"),
    $441d8a6a3f3441a0$var$load("kWSPH"),
    $441d8a6a3f3441a0$var$load("d4vRh"),
    $441d8a6a3f3441a0$var$load("31Cn4"),
    $441d8a6a3f3441a0$var$load("2YffH"),
    $441d8a6a3f3441a0$var$load("a90Gc"),
    $441d8a6a3f3441a0$var$load("hxZ7B"),
    $441d8a6a3f3441a0$var$load("h7P2N"),
    $441d8a6a3f3441a0$var$load("49LOG"),
    $441d8a6a3f3441a0$var$load("1P7J4"),
    $441d8a6a3f3441a0$var$load("fGTig"),
    $441d8a6a3f3441a0$var$load("fJtJG"),
    $441d8a6a3f3441a0$var$load("1GvGi"),
    $441d8a6a3f3441a0$var$load("d4u0p"),
    $441d8a6a3f3441a0$var$load("6KoKs"),
    $441d8a6a3f3441a0$var$load("cUIaj"),
    $441d8a6a3f3441a0$var$load("d63le"),
    $441d8a6a3f3441a0$var$load("l8GL7"),
    $441d8a6a3f3441a0$var$load("gVbhn"),
    $441d8a6a3f3441a0$var$load("lkOIY"),
    $441d8a6a3f3441a0$var$load("clQc9"),
    $441d8a6a3f3441a0$var$load("8PPsf"),
    $441d8a6a3f3441a0$var$load("iNp9w"),
    $441d8a6a3f3441a0$var$load("eBY1U"),
    $441d8a6a3f3441a0$var$load("dUz9k"),
    $441d8a6a3f3441a0$var$load("eXvGh"),
    $441d8a6a3f3441a0$var$load("9XYQ9"),
    $441d8a6a3f3441a0$var$load("bCoB0"),
    $441d8a6a3f3441a0$var$load("aJ9z1"),
    $441d8a6a3f3441a0$var$load("glvWr"),
    $441d8a6a3f3441a0$var$load("hshEG"),
    $441d8a6a3f3441a0$var$load("jTaSF"),
    $441d8a6a3f3441a0$var$load("9YBgR"),
    $441d8a6a3f3441a0$var$load("7ZIlR"),
    $441d8a6a3f3441a0$var$load("855o0"),
    $441d8a6a3f3441a0$var$load("8MfZE"),
    $441d8a6a3f3441a0$var$load("6wr18"),
    $441d8a6a3f3441a0$var$load("kjZZD"),
    $441d8a6a3f3441a0$var$load("9ZAzg"),
    $441d8a6a3f3441a0$var$load("kJSYP"),
    $441d8a6a3f3441a0$var$load("Wowvf"),
    $441d8a6a3f3441a0$var$load("cyGuT"),
    $441d8a6a3f3441a0$var$load("1qlDN"),
    $441d8a6a3f3441a0$var$load("1yVM6"),
    $441d8a6a3f3441a0$var$load("ffEVr"),
    $441d8a6a3f3441a0$var$load("hhss7"),
    $441d8a6a3f3441a0$var$load("avVwC"),
    $441d8a6a3f3441a0$var$load("9fieX"),
    $441d8a6a3f3441a0$var$load("7HyY8"),
    $441d8a6a3f3441a0$var$load("3yj56"),
    $441d8a6a3f3441a0$var$load("6mG00"),
    $441d8a6a3f3441a0$var$load("iqKwT"),
    $441d8a6a3f3441a0$var$load("kULV9"),
    $441d8a6a3f3441a0$var$load("19QIS"),
    $441d8a6a3f3441a0$var$load("kUbUu"),
    $441d8a6a3f3441a0$var$load("7EorR"),
    $441d8a6a3f3441a0$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("7MEO5", function(module, exports) {
"use strict";
var $5aacab81e886bd11$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5aacab81e886bd11$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxnq4 = parcelRequire("dxnq4");


$5aacab81e886bd11$var$__export((parcelRequire("3lrmR")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $5aacab81e886bd11$var$InvalidAriError = /** @class */ function(_super) {
    $5aacab81e886bd11$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $5aacab81e886bd11$var$InvalidAriError;
function $5aacab81e886bd11$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $5aacab81e886bd11$var$basicCharConstraint = $dxnq4.pattern(/^[a-z][a-z.-]*$/);
var $5aacab81e886bd11$var$resourceOwnerConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$resourceTypeConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$cloudIdConstraints = [
    $dxnq4.lengthBetween(36, 255)
];
var $5aacab81e886bd11$var$siteResourceType = 'site';
var $5aacab81e886bd11$var$resourceIdChars = /[\w-._~:@#]/.source;
var $5aacab81e886bd11$var$resourceIdConstraints = [
    $dxnq4.pattern(new RegExp("^" + $5aacab81e886bd11$var$resourceIdChars + "+(/" + $5aacab81e886bd11$var$resourceIdChars + "*)*(;v=" + $5aacab81e886bd11$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $5aacab81e886bd11$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $5aacab81e886bd11$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $5aacab81e886bd11$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $5aacab81e886bd11$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $5aacab81e886bd11$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $5aacab81e886bd11$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $5aacab81e886bd11$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $5aacab81e886bd11$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $5aacab81e886bd11$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $5aacab81e886bd11$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $5aacab81e886bd11$var$siteResourceType && !cloudId) return new $dxnq4.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $dxnq4.validateField(this, 'resourceOwner', $5aacab81e886bd11$var$resourceOwnerConstraints),
            $dxnq4.validateField(this, 'resourceType', $5aacab81e886bd11$var$resourceTypeConstraints),
            $dxnq4.validateField(this, 'resourceId', $5aacab81e886bd11$var$resourceIdConstraints),
            $dxnq4.validateField(this, 'cloudId', $5aacab81e886bd11$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $5aacab81e886bd11$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $5aacab81e886bd11$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $5aacab81e886bd11$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $5aacab81e886bd11$var$parse(ariString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $5aacab81e886bd11$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $5aacab81e886bd11$var$parseEncoded(encodedAriString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $5aacab81e886bd11$var$parseEncoded;

});

parcelRegister("dxnq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9db08607176ba86f$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $9db08607176ba86f$var$LengthConstraint;
var $9db08607176ba86f$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $9db08607176ba86f$var$RegexConstraint;
var $9db08607176ba86f$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $9db08607176ba86f$var$GeneralValidationError;
var $9db08607176ba86f$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $9db08607176ba86f$var$ConstraintViolation;
function $9db08607176ba86f$var$lengthBetween(min, max) {
    return new $9db08607176ba86f$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9db08607176ba86f$var$lengthBetween;
function $9db08607176ba86f$var$pattern(regex) {
    return new $9db08607176ba86f$var$RegexConstraint(regex);
}
module.exports.pattern = $9db08607176ba86f$var$pattern;
function $9db08607176ba86f$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $9db08607176ba86f$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9db08607176ba86f$var$validateField;

});

parcelRegister("3lrmR", function(module, exports) {
"use strict";
var $26f88fee2c23b642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uwoy = parcelRequire("3uwoy");

var $26f88fee2c23b642$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($26f88fee2c23b642$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $26f88fee2c23b642$var$AppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $26f88fee2c23b642$var$AppFamilyAriError;
var $26f88fee2c23b642$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $26f88fee2c23b642$var$NotAppFamilyAriError;
var $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $26f88fee2c23b642$var$parseAppAri(ari) {
    return $3uwoy.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $26f88fee2c23b642$var$parseAppAri;
function $26f88fee2c23b642$var$createAppAri(json) {
    return new $3uwoy.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $26f88fee2c23b642$var$createAppAri;

});

parcelRegister("3uwoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3lrmR = parcelRequire("3lrmR");


var $7MEO5 = parcelRequire("7MEO5");

var $28ad4d654e27c81d$var$versionPrefix = ';v=';
var $28ad4d654e27c81d$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $3lrmR.AppFamilyAri.resourceOwner) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $3lrmR.AppFamilyAri.resourceOwner);
        if (!resourceType || $3lrmR.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceType must be one of " + $3lrmR.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $3lrmR.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($28ad4d654e27c81d$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($28ad4d654e27c81d$var$versionPrefix) > versionIndex) throw new $3lrmR.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($28ad4d654e27c81d$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($28ad4d654e27c81d$var$stripToUndefined);
        if (segments.length > 4) throw new $3lrmR.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $3lrmR.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType || resourceType === $3lrmR.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $3lrmR.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $3lrmR.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $3lrmR.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $28ad4d654e27c81d$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $28ad4d654e27c81d$var$AppFamilyAriImpl;
function $28ad4d654e27c81d$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("cOau5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("fSxYU"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("fSxYU", function(module, exports) {

let $b8f6422d7c09d941$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8f6422d7c09d941$var$load("3XbzG").then(()=>parcelRequire('4s2T0'));

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $i5WUp = parcelRequire("i5WUp");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1o8l _1bah1h6o _1ul97vkz"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)(); // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        ...props,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $2XqLN.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("91MZ8"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("91MZ8", function(module, exports) {

let $692a3473ca8f6260$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $692a3473ca8f6260$var$load("3yj56"),
    $692a3473ca8f6260$var$load("6mG00"),
    $692a3473ca8f6260$var$load("kULV9"),
    $692a3473ca8f6260$var$load("6wr18"),
    $692a3473ca8f6260$var$load("kjZZD"),
    $692a3473ca8f6260$var$load("ffEVr"),
    $692a3473ca8f6260$var$load("9V45O"),
    $692a3473ca8f6260$var$load("4izLy"),
    $692a3473ca8f6260$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isShareableLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    JIRA: 'jira'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $dh538 = parcelRequire("dh538");


var $cOrQJ = parcelRequire("cOrQJ");


var $bHGk9 = parcelRequire("bHGk9");


var $ibFXh = parcelRequire("ibFXh");

var $1GJJf = parcelRequire("1GJJf");

var $aSy6D = parcelRequire("aSy6D");

var $8APLM = parcelRequire("8APLM");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");


var $cu1WV = parcelRequire("cu1WV");


var $aXOz9 = parcelRequire("aXOz9");

const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$export$a8a96573251792b1 = ({ url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const themeState = (0, $cOrQJ.default)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $aXOz9.initializeAnalyticsClient)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $aXOz9.onEditMode)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $aXOz9.constructUrl)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    const embeddedConfluenceSource = (()=>{
        try {
            const urlObj = new URL(formattedUrl);
            return urlObj.searchParams.get('embeddedConfluenceSource');
        } catch  {
            return null;
        }
    })();
    const runtimeProps = {
        url: formattedUrl,
        showFooter: false,
        hasFooterLogo: false,
        onModeChange: onModeChange,
        parentProduct: parentProduct,
        embeddedConfluenceSource: embeddedConfluenceSource && (0, $dh538.fg)('cc-integrations-project-pages-search-filtering') ? embeddedConfluenceSource : 'confluence-page-preview-panel',
        themeState: themeState
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3ZVni.PreviewPanelHeader), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                onClose: onClose,
                onOpenInNewTab: actions?.onOpenInNewTab,
                url: formattedUrl,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                        title: formatMessage((0, $cu1WV.messages).pageTitle),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    !!actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GJJf.PreviewPanelActionGroup), {
                        children: actions.onExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $8APLM.PreviewPanelExpand), {
                            onClick: actions.onExpand
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                styles: $178f91e075c3dc2a$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHGk9.EmbeddedConfluence), {
                    ...runtimeProps
                })
            })
        ]
    });
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>/*#__PURE__*/ (0, $l998X.jsx)($178f91e075c3dc2a$export$a8a96573251792b1, {
        url: url,
        parentProduct: parentProduct,
        cloudId: cloudId,
        panelData: panelData
    });
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent;
module.exports["ConfluencePagePreviewPanel"] = $178f91e075c3dc2a$export$a8a96573251792b1;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("bHGk9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $aqrhZ = parcelRequire("aqrhZ");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("1MqGu")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
            sourceComponent: 'EmbeddedConfluence',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4a221c0892a490b0$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($4a221c0892a490b0$var$LazyEmbeddedConfluence, {
                    ...props
                })
            })
        })
    });
module.exports["EmbeddedConfluence"] = $4a221c0892a490b0$export$c4789cfd0b0cd2c4;

});

parcelRegister("1MqGu", function(module, exports) {

let $14bef9128349c0f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14bef9128349c0f3$var$load("jTaSF"),
    $14bef9128349c0f3$var$load("Wowvf"),
    $14bef9128349c0f3$var$load("hhss7"),
    $14bef9128349c0f3$var$load("iqKwT"),
    $14bef9128349c0f3$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("1GJJf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center",
        children: children
    });
};
module.exports["PreviewPanelActionGroup"] = $1fc8fb56653d2345$export$b3bbf50939c515ce;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        children: children
    });
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("8APLM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lOzEN = parcelRequire("lOzEN");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelExpand"] = $91e6116a3cc9352a$export$40b251582cb3e1fe;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("39XmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84bdce2dbfd750d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $fFa3V = parcelRequire("fFa3V");


var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $a4UIB = parcelRequire("a4UIB");


var $26AWB = parcelRequire("26AWB");


var $5O1V9 = parcelRequire("5O1V9");

function $f84bdce2dbfd750d$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $42omo.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const shouldDisable = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $5spQU.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $T9xHm.isFedrampModerate)();
    const isEnabled = !shouldDisable;
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $42omo.useMemo)(()=>{
        if (isEnabled) return new (0, $a4UIB.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $fFa3V.bind)(document, {
                type: (0, $5O1V9.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $26AWB.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("cu1WV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});
module.exports["messages"] = $11543dd8ad4b06d3$export$defe85febe8b728c;

});

parcelRegister("aXOz9", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kFwgS = parcelRequire("kFwgS");

var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};
module.exports["onEditMode"] = $8f94b4972688fbbf$export$232fd46a0431e57a;
module.exports["initializeAnalyticsClient"] = $8f94b4972688fbbf$export$7d842b959fcdcd03;
module.exports["constructUrl"] = $8f94b4972688fbbf$export$a639a54e55b70225;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("7ShCl", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $cgtv4.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $cgtv4 = parcelRequire("cgtv4");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $cgtv4.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("4iPjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $74848600c16eb369$export$2e2bcd8739ae039);

var $aqrhZ = parcelRequire("aqrhZ");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("5sNei")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$74848600c16eb369$export$2e2bcd8739ae039 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $knjgj.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lQSkW.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)($99bf16152ad1d840$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $918lS.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $jrfDA.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $56c0565d5892d700$var$useConstructor(()=>(0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $l998X.jsx)($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback),
        children: children
    });
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {});
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $cgtv4.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $8C5kA.default)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $atwsN.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c2ARh.GenericErrorSVG), {}),
            description: description
        })
    });
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab7LA.LazyMessagesProvider), {
        children: children
    });
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale),
        children: children
    });
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("f7ay8")),
    da: ()=>(parcelRequire("b8C5q")),
    de: ()=>(parcelRequire("55goX")),
    en_GB: ()=>(parcelRequire("2Qboj")),
    en_ZZ: ()=>(parcelRequire("hbhqt")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("0176Z")),
    fi: ()=>(parcelRequire("8EsTm")),
    fr: ()=>(parcelRequire("6Aa8Y")),
    hu: ()=>(parcelRequire("98QWJ")),
    it: ()=>(parcelRequire("axMLV")),
    ja: ()=>(parcelRequire("9iWPv")),
    ko: ()=>(parcelRequire("it5VZ")),
    nb: ()=>(parcelRequire("eMImy")),
    nl: ()=>(parcelRequire("ldo9S")),
    pl: ()=>(parcelRequire("8KXjl")),
    pt_BR: ()=>(parcelRequire("cKLZb")),
    ru: ()=>(parcelRequire("eQGp4")),
    sv: ()=>(parcelRequire("foUuI")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("rmgqA")),
    zh: ()=>(parcelRequire("2d7NW"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("f7ay8", function(module, exports) {

let $b00fb167ccbb4de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b00fb167ccbb4de3$var$load("4Mixi"),
    $b00fb167ccbb4de3$var$load("1jsQH"),
    $b00fb167ccbb4de3$var$load("bv8GZ"),
    $b00fb167ccbb4de3$var$load("i5eMd"),
    $b00fb167ccbb4de3$var$load("4DYJ5"),
    $b00fb167ccbb4de3$var$load("gyXEE"),
    $b00fb167ccbb4de3$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("b8C5q", function(module, exports) {

let $81bdfc3e9940061d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81bdfc3e9940061d$var$load("cjveN"),
    $81bdfc3e9940061d$var$load("deyvi"),
    $81bdfc3e9940061d$var$load("cdeuH"),
    $81bdfc3e9940061d$var$load("4UPfH"),
    $81bdfc3e9940061d$var$load("hfFxJ"),
    $81bdfc3e9940061d$var$load("1Mp9N"),
    $81bdfc3e9940061d$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("55goX", function(module, exports) {

let $3b3a245be243f89c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b3a245be243f89c$var$load("8XGJb"),
    $3b3a245be243f89c$var$load("6dERU"),
    $3b3a245be243f89c$var$load("7gF8f"),
    $3b3a245be243f89c$var$load("gd4qs"),
    $3b3a245be243f89c$var$load("gofGr"),
    $3b3a245be243f89c$var$load("dBb6q"),
    $3b3a245be243f89c$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("2Qboj", function(module, exports) {

let $21194624c4e264ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21194624c4e264ab$var$load("hdvZr"),
    $21194624c4e264ab$var$load("kTurq"),
    $21194624c4e264ab$var$load("djb49"),
    $21194624c4e264ab$var$load("fviv5"),
    $21194624c4e264ab$var$load("2RQvP"),
    $21194624c4e264ab$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("hbhqt", function(module, exports) {

let $c820fb36586af294$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c820fb36586af294$var$load("4ViGN"),
    $c820fb36586af294$var$load("j0PWv"),
    $c820fb36586af294$var$load("ksTQ6"),
    $c820fb36586af294$var$load("eBoC7"),
    $c820fb36586af294$var$load("7NpX8"),
    $c820fb36586af294$var$load("cukQS"),
    $c820fb36586af294$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("0176Z", function(module, exports) {

let $00359c5d50f0804f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00359c5d50f0804f$var$load("32vlK"),
    $00359c5d50f0804f$var$load("dlmud"),
    $00359c5d50f0804f$var$load("5CGnz"),
    $00359c5d50f0804f$var$load("bNv64"),
    $00359c5d50f0804f$var$load("bFU3Y"),
    $00359c5d50f0804f$var$load("3CucM"),
    $00359c5d50f0804f$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("8EsTm", function(module, exports) {

let $64c878837647bdf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64c878837647bdf9$var$load("bjoGV"),
    $64c878837647bdf9$var$load("cbkj0"),
    $64c878837647bdf9$var$load("9Oxgj"),
    $64c878837647bdf9$var$load("4Afgd"),
    $64c878837647bdf9$var$load("exaJ2"),
    $64c878837647bdf9$var$load("lp8Wm"),
    $64c878837647bdf9$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("6Aa8Y", function(module, exports) {

let $4cadf92e042c2e65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cadf92e042c2e65$var$load("8oiz7"),
    $4cadf92e042c2e65$var$load("17m16"),
    $4cadf92e042c2e65$var$load("kAg8V"),
    $4cadf92e042c2e65$var$load("cMubu"),
    $4cadf92e042c2e65$var$load("hcCcg"),
    $4cadf92e042c2e65$var$load("cHWSM"),
    $4cadf92e042c2e65$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("98QWJ", function(module, exports) {

let $6a7dee6b830696fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7dee6b830696fd$var$load("hFxmj"),
    $6a7dee6b830696fd$var$load("b4NO6"),
    $6a7dee6b830696fd$var$load("fM2oh"),
    $6a7dee6b830696fd$var$load("3fLE9"),
    $6a7dee6b830696fd$var$load("j9KTb"),
    $6a7dee6b830696fd$var$load("b37xN"),
    $6a7dee6b830696fd$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("axMLV", function(module, exports) {

let $7ad2d18c5b7fb3bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ad2d18c5b7fb3bd$var$load("BXOZB"),
    $7ad2d18c5b7fb3bd$var$load("1K1Fj"),
    $7ad2d18c5b7fb3bd$var$load("xnqy2"),
    $7ad2d18c5b7fb3bd$var$load("8hOn0"),
    $7ad2d18c5b7fb3bd$var$load("3hjAq"),
    $7ad2d18c5b7fb3bd$var$load("7PjNK"),
    $7ad2d18c5b7fb3bd$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("9iWPv", function(module, exports) {

let $6c636dd744267993$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c636dd744267993$var$load("9Xiuh"),
    $6c636dd744267993$var$load("38sfA"),
    $6c636dd744267993$var$load("awkVi"),
    $6c636dd744267993$var$load("h4OCL"),
    $6c636dd744267993$var$load("2bCHJ"),
    $6c636dd744267993$var$load("ktSfi"),
    $6c636dd744267993$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("it5VZ", function(module, exports) {

let $d71f89e15ac436bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d71f89e15ac436bf$var$load("7Odo3"),
    $d71f89e15ac436bf$var$load("bjmre"),
    $d71f89e15ac436bf$var$load("11DLa"),
    $d71f89e15ac436bf$var$load("bcQs2"),
    $d71f89e15ac436bf$var$load("fdXnq"),
    $d71f89e15ac436bf$var$load("iouLY"),
    $d71f89e15ac436bf$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("eMImy", function(module, exports) {

let $ac37f5eeb4137d23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac37f5eeb4137d23$var$load("4VkvT"),
    $ac37f5eeb4137d23$var$load("asvK9"),
    $ac37f5eeb4137d23$var$load("barSq"),
    $ac37f5eeb4137d23$var$load("aBa7j"),
    $ac37f5eeb4137d23$var$load("cItJR"),
    $ac37f5eeb4137d23$var$load("hPZE5"),
    $ac37f5eeb4137d23$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("ldo9S", function(module, exports) {

let $f71d8d3405ac63de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f71d8d3405ac63de$var$load("g5qJV"),
    $f71d8d3405ac63de$var$load("7v6wU"),
    $f71d8d3405ac63de$var$load("a8heY"),
    $f71d8d3405ac63de$var$load("b544F"),
    $f71d8d3405ac63de$var$load("SctKm"),
    $f71d8d3405ac63de$var$load("dzIm8"),
    $f71d8d3405ac63de$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("8KXjl", function(module, exports) {

let $6600a08dfb81ea85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6600a08dfb81ea85$var$load("dPa6p"),
    $6600a08dfb81ea85$var$load("aEpRh"),
    $6600a08dfb81ea85$var$load("6hlNE"),
    $6600a08dfb81ea85$var$load("K6fhx"),
    $6600a08dfb81ea85$var$load("1fJz1"),
    $6600a08dfb81ea85$var$load("jqwnR"),
    $6600a08dfb81ea85$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("cKLZb", function(module, exports) {

let $948f00e640b5806f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $948f00e640b5806f$var$load("iG4uh"),
    $948f00e640b5806f$var$load("3fuR9"),
    $948f00e640b5806f$var$load("2bqSD"),
    $948f00e640b5806f$var$load("gZU54"),
    $948f00e640b5806f$var$load("9yA8o"),
    $948f00e640b5806f$var$load("bGhLc"),
    $948f00e640b5806f$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("eQGp4", function(module, exports) {

let $acf6d07201fb1e6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $acf6d07201fb1e6d$var$load("9tVE8"),
    $acf6d07201fb1e6d$var$load("fMrUo"),
    $acf6d07201fb1e6d$var$load("bJykp"),
    $acf6d07201fb1e6d$var$load("4Wdqb"),
    $acf6d07201fb1e6d$var$load("448N7"),
    $acf6d07201fb1e6d$var$load("9v6ER"),
    $acf6d07201fb1e6d$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("foUuI", function(module, exports) {

let $b364eb80f1c4e250$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b364eb80f1c4e250$var$load("6UAlo"),
    $b364eb80f1c4e250$var$load("9eNkX"),
    $b364eb80f1c4e250$var$load("dh2Er"),
    $b364eb80f1c4e250$var$load("k10Cs"),
    $b364eb80f1c4e250$var$load("gBDdh"),
    $b364eb80f1c4e250$var$load("8Mz40"),
    $b364eb80f1c4e250$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("rmgqA", function(module, exports) {

let $0523cae41db9f363$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0523cae41db9f363$var$load("ia9y3"),
    $0523cae41db9f363$var$load("j9OUx"),
    $0523cae41db9f363$var$load("bV8sS"),
    $0523cae41db9f363$var$load("l079e"),
    $0523cae41db9f363$var$load("ebljE"),
    $0523cae41db9f363$var$load("hF4v3"),
    $0523cae41db9f363$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("2d7NW", function(module, exports) {

let $19c2d97ac60aba4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19c2d97ac60aba4a$var$load("15ncj"),
    $19c2d97ac60aba4a$var$load("gDiIK"),
    $19c2d97ac60aba4a$var$load("eLlpV"),
    $19c2d97ac60aba4a$var$load("f1B4n"),
    $19c2d97ac60aba4a$var$load("j4dSZ"),
    $19c2d97ac60aba4a$var$load("1Tuyb"),
    $19c2d97ac60aba4a$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("5sNei", function(module, exports) {

let $3fa5c13c79bdd9be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3fa5c13c79bdd9be$var$load("9XYQ9"),
    $3fa5c13c79bdd9be$var$load("6wr18"),
    $3fa5c13c79bdd9be$var$load("7EorR"),
    $3fa5c13c79bdd9be$var$load("ffEVr"),
    $3fa5c13c79bdd9be$var$load("Wowvf"),
    $3fa5c13c79bdd9be$var$load("kHOMt"),
    $3fa5c13c79bdd9be$var$load("hhss7"),
    $3fa5c13c79bdd9be$var$load("eTYdV"),
    $3fa5c13c79bdd9be$var$load("kULV9"),
    $3fa5c13c79bdd9be$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $d7ZU3 = parcelRequire("d7ZU3");

var $led7c = parcelRequire("led7c");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("kZ5GD", function(module, exports) {
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$radioStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo _mqf81gmx _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $gMc0m.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd _iosijmqp _11jyjmqp _f3ett94y _19ybs4qr _1d7ps4qr _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4ryaby5v _o1bdby5v _2kbkby5v _6cyrby5v _n8t0by5v _1o5rby5v _nxi6by5v _neoeby5v _1el2by5v _lekrbk0g _11v7bk0g _1if1bk0g _bl0ebk0g _92nabk0g _awurbk0g _1f8cbk0g _s2ftbk0g _17a1bk0g _x48a2sac _1ib22sac _wml02sac _tusm2sac _1c6f2sac _qftt2sac _1yk92sac _gdmb2sac _pmm42sac _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r"
                ])
            }),
            label ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("a6t12", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $dD7ks = parcelRequire("dD7ks");


var $9wGTI = parcelRequire("9wGTI");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { position: t1, userId: userId, isAnonymous: t2, canViewProfile: t3, children: children, trigger: t4, fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel } = t0;
    const position = t1 === undefined ? "bottom-start" : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const canViewProfile = t3 === undefined ? true : t3;
    const trigger = t4 === undefined ? "hover" : t4;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            type: "LANDING"
        };
        $[0] = t5;
    } else t5 = $[0];
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)(t5);
    let t6;
    if ($[1] !== orgId) {
        t6 = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || "", {
                type: "USER",
                payload: {
                    userId: clickedUserId
                }
            });
        $[1] = orgId;
        $[2] = t6;
    } else t6 = $[2];
    const getReportingLinesUserProfile = t6;
    const t7 = userId || "";
    let t8;
    if ($[3] !== t7) {
        t8 = {
            type: "USER",
            payload: {
                userId: t7
            }
        };
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)(t8);
    let t9;
    if ($[5] !== reportingLines) {
        t9 = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
        $[5] = reportingLines;
        $[6] = t9;
    } else t9 = $[6];
    const reportingLinesProfileUrl = t9;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    let t10;
    if ($[7] !== push || $[8] !== userId || $[9] !== userProfile) {
        t10 = (0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        });
        $[7] = push;
        $[8] = userId;
        $[9] = userProfile;
        $[10] = t10;
    } else t10 = $[10];
    const viewProfileAction = t10;
    let t11;
    if ($[11] !== followedUsers || $[12] !== getToggleFollowUser || $[13] !== loggedInUserId || $[14] !== renderFeedFollow || $[15] !== userId) {
        t11 = $3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        });
        $[11] = followedUsers;
        $[12] = getToggleFollowUser;
        $[13] = loggedInUserId;
        $[14] = renderFeedFollow;
        $[15] = userId;
        $[16] = t11;
    } else t11 = $[16];
    const followUserAction = t11;
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) {
        let t12;
        if ($[17] !== children) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[17] = children;
            $[18] = t12;
        } else t12 = $[18];
        return t12;
    }
    let t12;
    if ($[19] !== createAnalyticsEvent || $[20] !== getReportingLinesUserProfile || $[21] !== push) {
        t12 = (clickedUserId_0)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "profileCardWrapper",
                    action: "clicked",
                    actionSubject: "viewProfile",
                    actionSubjectId: "userProfileCard",
                    attributes: {
                        clickTarget: "userReportingLine"
                    }
                }
            }).fire();
            if ((0, $5XsiK.isTeamsAppEnabled)()) {
                getReportingLinesUserProfile(clickedUserId_0).onNavigate();
                return false;
            }
            if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, "", (0, $jlIaF.CONTEXT_PATH)), "_blank", "noreferrer");
            else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, $3d0f3ea3171aff68$var$_temp);
        };
        $[19] = createAnalyticsEvent;
        $[20] = getReportingLinesUserProfile;
        $[21] = push;
        $[22] = t12;
    } else t12 = $[22];
    const reportingLinesClickCallback = t12;
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== ariaLabel || $[25] !== children || $[26] !== cloudId || $[27] !== disabledAriaAttributes || $[28] !== featureFlags || $[29] !== feedConfigError || $[30] !== followUserAction || $[31] !== fullName || $[32] !== isVisible || $[33] !== loggedInUserId || $[34] !== mutationError || $[35] !== offset || $[36] !== onVisibilityChange || $[37] !== position || $[38] !== reportingLinesClickCallback || $[39] !== reportingLinesProfileUrl || $[40] !== trigger || $[41] !== userId || $[42] !== viewProfileAction) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t13
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
                feedConfigError: feedConfigError,
                mutationError: mutationError,
                showErrorFlag: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
                cloudId: cloudId,
                userId: userId,
                resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
                position: position,
                trigger: trigger,
                actions: [
                    viewProfileAction,
                    followUserAction
                ],
                reportingLinesProfileUrl: reportingLinesProfileUrl,
                onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
                addFlag: (flag)=>flags.showFlag(flag),
                prepopulatedData: {
                    fullName: fullName
                },
                disabledAriaAttributes: disabledAriaAttributes,
                isVisible: (0, $9wGTI.fg)("fix_profilecard_trigger_isvisible") ? undefined : isVisible,
                onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                    setIsVisible(changedIsVisible);
                }),
                offset: offset,
                testId: "profileCardTrigger",
                viewingUserId: loggedInUserId,
                ...disabledAriaAttributes ? {} : {
                    ariaLabel: ariaLabel
                }
            }, children)));
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = cloudId;
        $[27] = disabledAriaAttributes;
        $[28] = featureFlags;
        $[29] = feedConfigError;
        $[30] = followUserAction;
        $[31] = fullName;
        $[32] = isVisible;
        $[33] = loggedInUserId;
        $[34] = mutationError;
        $[35] = offset;
        $[36] = onVisibilityChange;
        $[37] = position;
        $[38] = reportingLinesClickCallback;
        $[39] = reportingLinesProfileUrl;
        $[40] = trigger;
        $[41] = userId;
        $[42] = viewProfileAction;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
};
function $3d0f3ea3171aff68$var$_temp() {}
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("bedVD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $cgtv4.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $eSUdr.default)`query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}`;
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $eSUdr.default)`mutation useFeedFollowFeedFollowMutation($follow:[ID]$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow unfollowUsers:$unfollow}){success}}`;
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $xQxzY.useQuery)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error)
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $1KmJq.useMutation)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            },
            'FeedFollowQuery'
        ]
    });
    const followedUsers = data?.getFeedUserConfig?.accountIds;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch (_) {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    const feedFollowData = {
        renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
        loading: queryLoading,
        getToggleFollowUser: getToggleFollowUser,
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        followedUsers: followedUsers
    };
    const feedFollowDataMemoized = (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? feedFollowDataMemoized : feedFollowData;
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $hp2SH = parcelRequire("hp2SH");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const UserProfileClientForConfluencePromise = (0, $hp2SH.getApolloClient)().query({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            }
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/**
 * @generated SignedSource<<6837b1662181fa3feff08f9973248f40>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $eSUdr.default)`query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false id:$userId){id confluence{permissionType}}entitlements{externalCollaborator{isEntitled}}}`;
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("gj42z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("8lYIw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8T1Wf = parcelRequire("8T1Wf");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("8T1Wf", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6784f6b3e56cd8b3$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6784f6b3e56cd8b3$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $6784f6b3e56cd8b3$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fgJFQ.createLocation)(to, null, null, currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef === "undefined") $6784f6b3e56cd8b3$var$forwardRef = $6784f6b3e56cd8b3$var$forwardRefShim;
function $6784f6b3e56cd8b3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6784f6b3e56cd8b3$var$LinkAnchor = $6784f6b3e56cd8b3$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6784f6b3e56cd8b3$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a = $6784f6b3e56cd8b3$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6784f6b3e56cd8b3$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6784f6b3e56cd8b3$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $fgJFQ.createPath)(context.location) === (0, $fgJFQ.createPath)($6784f6b3e56cd8b3$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $6784f6b3e56cd8b3$var$toType, $6784f6b3e56cd8b3$var$refType;
var $6784f6b3e56cd8b3$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef$1 === "undefined") $6784f6b3e56cd8b3$var$forwardRef$1 = $6784f6b3e56cd8b3$var$forwardRefShim$1;
function $6784f6b3e56cd8b3$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6784f6b3e56cd8b3$export$b0d92dbee9b5b60d = $6784f6b3e56cd8b3$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6784f6b3e56cd8b3$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim$1 !== $6784f6b3e56cd8b3$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784f6b3e56cd8b3$export$a6c7ac8248d6e38a, props);
    });
});
var $6784f6b3e56cd8b3$var$ariaCurrentType;
module.exports["Link"] = $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a;

});

parcelRegister("9Z0wk", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $5e18336ff60a0b69$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $5e18336ff60a0b69$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $gMc0m.default)([
            $5e18336ff60a0b69$var$editedContentStyles.root
        ]),
        children: children
    });
$5e18336ff60a0b69$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5e18336ff60a0b69$export$2e2bcd8739ae039 = $5e18336ff60a0b69$var$Edited;
module.exports["default"] = $5e18336ff60a0b69$export$2e2bcd8739ae039;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("b71PS"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("b71PS", function(module, exports) {

let $8171c5ae6262a18b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8171c5ae6262a18b$var$load("6wr18"),
    $8171c5ae6262a18b$var$load("ffEVr"),
    $8171c5ae6262a18b$var$load("Wowvf"),
    $8171c5ae6262a18b$var$load("hhss7"),
    $8171c5ae6262a18b$var$load("cyGuT"),
    $8171c5ae6262a18b$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7EIq6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(15);
    const t0 = spaceKey !== undefined;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== t0) {
        t2 = {
            skip: t0,
            variables: t1
        };
        $[1] = t0;
        $[2] = t2;
    } else t2 = $[2];
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t2);
    const t3 = !spaceKey && !defaultSpaceKeyData;
    const t4 = spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id;
    let t5;
    if ($[3] !== t4) {
        t5 = {
            spaceKey: t4
        };
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = {
            errorPolicy: "all",
            skip: t3,
            variables: t5
        };
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const spaceEnabledContentTypesQueryOptions = t6;
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    let t7;
    if ($[8] !== isCreateBlogEnabled || $[9] !== isCreateDatabaseEnabled || $[10] !== isCreateFolderEnabled || $[11] !== isCreateLiveDocEnabled || $[12] !== isCreateSmartLinkEnabled || $[13] !== isCreateWhiteboardEnabled) {
        t7 = {
            isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
            isCreateBlogEnabled: isCreateBlogEnabled,
            isCreateDatabaseEnabled: isCreateDatabaseEnabled,
            isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
            isCreateLiveDocEnabled: isCreateLiveDocEnabled,
            isCreateFolderEnabled: isCreateFolderEnabled
        };
        $[8] = isCreateBlogEnabled;
        $[9] = isCreateDatabaseEnabled;
        $[10] = isCreateFolderEnabled;
        $[11] = isCreateLiveDocEnabled;
        $[12] = isCreateSmartLinkEnabled;
        $[13] = isCreateWhiteboardEnabled;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");


var $jf9LK = parcelRequire("jf9LK");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))) {
            const activeFeatureGate = featureName;
            const featureGateKey = (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))[activeFeatureGate];
            return (0, $9wGTI.fg)(featureGateKey);
        }
        return false;
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("jf9LK", function(module, exports) {
module.exports = JSON.parse("{\"whiteboardSolidHeader\":\"confluence_frontend_solid_whiteboard_header\",\"whiteboardOptOut\":\"whiteboards_compliance_opt_out\",\"digitalTeammate\":\"cc-ai-whiteboards-enable-digital-teammate\",\"aiFirstCreation\":\"aifc_create_enabled\"}");

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(6);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $xQxzY.useQuery)(t0, t3);
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $cgtv4.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1G4Mp"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1G4Mp"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("1G4Mp", function(module, exports) {

let $138d6bd502047ad8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $138d6bd502047ad8$var$load("9V45O"),
    $138d6bd502047ad8$var$load("kULV9"),
    $138d6bd502047ad8$var$load("7aOpi"),
    $138d6bd502047ad8$var$load("gq5DC"),
    $138d6bd502047ad8$var$load("kWSPH"),
    $138d6bd502047ad8$var$load("jXx9i"),
    $138d6bd502047ad8$var$load("9ftJe"),
    $138d6bd502047ad8$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("2igSQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko458z _bfhk1s93",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1nmz9jpi _syazi7uo _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko18r2 _syaz1rpy _bfhk1s93 _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $6Ipjn = parcelRequire("6Ipjn");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $42omo.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $42omo.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            // @ts-ignore cols used to be in the list of props of TextArea but later then removed
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        // @ts-ignore cols used to be in the list of props of TextArea but later then removed
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("hHZWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("euF5O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("6nXDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a6325bd22772a7a$export$2e2bcd8739ae039);

var $c3Z6w = parcelRequire("c3Z6w");


var $b5utg = parcelRequire("b5utg");

function $4a6325bd22772a7a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b5utg.default)(1, arguments);
    return (0, $c3Z6w.default)(dirtyDate, Date.now(), options);
}

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("8Fgdk"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("8Fgdk", function(module, exports) {

let $64eebad0de5c90fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64eebad0de5c90fe$var$load("2F69B"),
    $64eebad0de5c90fe$var$load("iMSgb"),
    $64eebad0de5c90fe$var$load("9a2oY"),
    $64eebad0de5c90fe$var$load("hhss7"),
    $64eebad0de5c90fe$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("8EF7j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6242f603ec1727a8ab94c75bc410d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64d1f41eb9b7eee3$var$_react = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("42omo")));

var $64d1f41eb9b7eee3$var$_baseNew = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $64d1f41eb9b7eee3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $64d1f41eb9b7eee3$var$_react.default.createElement($64d1f41eb9b7eee3$var$_baseNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $64d1f41eb9b7eee3$var$_default = module.exports.default = $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;

});

parcelRegister("8a9Dm", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey && (0, $9wGTI.fg)('confluence-fe-migrated-custom-content-display-fix')) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("62fWd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $6fRDv = parcelRequire("6fRDv");


var $dh538 = parcelRequire("dh538");

let $3c9dbf4421667f34$var$postRobotOn = null;

// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $3c9dbf4421667f34$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children, localId: localId, isCustomConfig: isCustomConfig })=>{
    // Listen for analytics events from child iframes (FAUS)
    (0, $42omo.useEffect)(()=>{
        if (localId && $3c9dbf4421667f34$var$postRobotOn && !isCustomConfig && (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus')) {
            const allowedDomain = (0, $6fRDv.getProductDomain)();
            const listener = $3c9dbf4421667f34$var$postRobotOn(`analyticsFromEmbeddedFAUS_${localId}`, {
                domain: allowedDomain
            }, async ({ data: data })=>{
                // Forward to the product's analytics client using the existing sendEvent utility
                (0, $3Spjc.sendEvent)(analyticsWebClient)(data);
            });
            return ()=>{
                listener.cancel();
            };
        }
    }, [
        analyticsWebClient,
        localId,
        isCustomConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("6fRDv", function(module, exports) {
/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */ function $1ed0c4b4d8f6d1ca$export$532d4b4b6d3d2c95() {
    // This would need to be changed if we want to support multiple nesting levels
    const targetWindow = window.parent?.parent;
    // Ensure we have a valid target that's not the current window
    if (targetWindow && targetWindow !== window) return targetWindow;
    return null;
}
function $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e() {
    return `${window.location.protocol}//${window.location.hostname}`;
}
module.exports["getProductDomain"] = $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e;

});

parcelRegister("fy6ox", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $5d73e8e60584e113$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$5d73e8e60584e113$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d73e8e60584e113$export$2e2bcd8739ae039 = $5d73e8e60584e113$var$Author;
module.exports["default"] = $5d73e8e60584e113$export$2e2bcd8739ae039;

});

parcelRegister("7tyMu", function(module, exports) {
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

const $a24e02791d90685a$var$textStyles = {
    root: "_syazazsu"
};
const $a24e02791d90685a$var$anchorStyles = {
    root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz"
};
const $a24e02791d90685a$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $a24e02791d90685a$var$hasAuthorStyles = {
    root: "_k48p1wq8"
}; /**
    * __Field__
    *
    * A field appears in the comment header to add metadata to the comment.
    *
    * @internal
    */ 
const $a24e02791d90685a$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        xcss: (0, $1Whri.cx)($a24e02791d90685a$var$textStyles.root, $a24e02791d90685a$var$anchorStyles.root, hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("span" /**
                     * It is not normally acceptable to add key handlers to non-interactive elements
                     * as this is an accessibility anti-pattern. However, because this instance is
                     * to add support for analytics instead of creating an inaccessible
                     * custom element, we can add role="presentation" so that there are no negative
                     * impacts to assistive technologies.
                     */ , {
        role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $a24e02791d90685a$var$textStyles.root,
            hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $a24e02791d90685a$export$2e2bcd8739ae039 = $a24e02791d90685a$var$Field;
module.exports["default"] = $a24e02791d90685a$export$2e2bcd8739ae039;

});

parcelRegister("fJJGs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $d3930f6319807484$var$CommentTime = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentTime',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$d3930f6319807484$var$CommentTime.displayName = 'CommentTime';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3930f6319807484$export$2e2bcd8739ae039 = $d3930f6319807484$var$CommentTime;
module.exports["default"] = $d3930f6319807484$export$2e2bcd8739ae039;

});

parcelRegister("hlzjm", function(module, exports) {
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $bVeqx = parcelRequire("bVeqx");


var $cV7U6 = parcelRequire("cV7U6");


var $ijtAN = parcelRequire("ijtAN");

const $93d62a86395aa94f$var$textStyles = {
    root: "_syazi7uo",
    disabled: "_syaz1gmx"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $93d62a86395aa94f$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ijtAN.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cV7U6.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $1Whri.cx)($93d62a86395aa94f$var$textStyles.root, (isSaving || isError) && $93d62a86395aa94f$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bVeqx.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$93d62a86395aa94f$var$Comment.displayName = 'Comment';
var $93d62a86395aa94f$export$2e2bcd8739ae039 = $93d62a86395aa94f$var$Comment;
module.exports["default"] = $93d62a86395aa94f$export$2e2bcd8739ae039;

});

parcelRegister("bVeqx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ebrpi = parcelRequire("ebrpi");


var $dcJ7R = parcelRequire("dcJ7R");


var $6fnsQ = parcelRequire("6fnsQ");

/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $d2b873e75f9e4281$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$d2b873e75f9e4281$var$Footer.displayName = 'CommentFooter';
var $d2b873e75f9e4281$export$2e2bcd8739ae039 = $d2b873e75f9e4281$var$Footer;
module.exports["default"] = $d2b873e75f9e4281$export$2e2bcd8739ae039;

});

parcelRegister("cV7U6", function(module, exports) {
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9Q2dU = parcelRequire("9Q2dU");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $09aac408a5a8747f$var$headingStyles = {
    root: "_11c8fhey"
};
const $09aac408a5a8747f$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
};
const $09aac408a5a8747f$var$headerItemStyles = {
    root: "_o5721q9c _1o9zidpf"
};
const $09aac408a5a8747f$var$authorBoxStyles = {
    root: "_1nmz9jpi _1ul9idpf _p12f1osq"
}; /**
    * __Header items__
    *
    * Comment header items.
    *
    * @internal
    */ 
const $09aac408a5a8747f$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $l998X.jsx)(Heading, {
        className: (0, $gMc0m.default)([
            $09aac408a5a8747f$var$headingStyles.root
        ]),
        children: shouldHeaderWrap === false ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: false,
            children: [
                author,
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            rowSpace: "space.0",
            as: "span",
            shouldWrap: true,
            children: [
                author && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$authorBoxStyles.root,
                    children: author
                }),
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        testId: testId && `${testId}-type`,
                        children: type
                    })
                }),
                time && !isSaving && !isError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: time
                }),
                edited && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: edited
                }),
                isSaving && savingText && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: savingText
                }),
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.050",
                            as: "span",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    as: "span",
                                    xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                        color: "currentColor",
                                        label: "",
                                        size: "small"
                                    })
                                }),
                                restrictedTo
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
$09aac408a5a8747f$var$Header.displayName = 'CommentHeader';
var $09aac408a5a8747f$export$2e2bcd8739ae039 = $09aac408a5a8747f$var$Header;
module.exports["default"] = $09aac408a5a8747f$export$2e2bcd8739ae039;

});

parcelRegister("ijtAN", function(module, exports) {
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");


var $6JC10 = parcelRequire("6JC10");


var $lmM8h = parcelRequire("lmM8h");

const $768cc646e91e2e58$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $768cc646e91e2e58$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $768cc646e91e2e58$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $768cc646e91e2e58$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $768cc646e91e2e58$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $768cc646e91e2e58$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        gap: "space.100",
        xcss: (0, $1Whri.cx)($768cc646e91e2e58$var$containerStyles.root, shouldRenderNestedCommentsInline && $768cc646e91e2e58$var$inlineCommentStyles.root, !children && $768cc646e91e2e58$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $l998X.jsx)((0, $6JC10.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $l998X.jsx)((0, $lmM8h.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                xcss: $768cc646e91e2e58$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $768cc646e91e2e58$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$768cc646e91e2e58$var$Layout.displayName = 'CommentLayout';
var $768cc646e91e2e58$export$2e2bcd8739ae039 = $768cc646e91e2e58$var$Layout;
module.exports["default"] = $768cc646e91e2e58$export$2e2bcd8739ae039;

});

parcelRegister("6JC10", function(module, exports) {
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $d6ff3474eb3a1c0a$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $d6ff3474eb3a1c0a$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d6ff3474eb3a1c0a$var$avatarSectionStyles.root,
        children: children
    });
var $d6ff3474eb3a1c0a$export$2e2bcd8739ae039 = $d6ff3474eb3a1c0a$var$AvatarSlot;
module.exports["default"] = $d6ff3474eb3a1c0a$export$2e2bcd8739ae039;

});

parcelRegister("lmM8h", function(module, exports) {
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $df8b60abd3030907$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
const $df8b60abd3030907$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $df8b60abd3030907$var$contentSlotStyles.root
        ]),
        children: children
    });
var $df8b60abd3030907$export$2e2bcd8739ae039 = $df8b60abd3030907$var$ContentSlot;
module.exports["default"] = $df8b60abd3030907$export$2e2bcd8739ae039;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    // Clear the override state when navigating to a different page
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const widthValue = metadata?.editorWidth?.value;
            const version = metadata?.editorWidth?.version;
            if (widthValue) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
		Previous check was:
		const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
		which always returns contentAppearanceQuery
	*/ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        return {
            contentAppearance: contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("lKNXy", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("bDfDA"))).ConnectAddon,
    name: 'ConnectAddonNext'
});
module.exports["ConnectAddon"] = $d2cf06290ddd4b8d$export$1679e39403bb0c0c;

});

parcelRegister("bDfDA", function(module, exports) {

let $877f77819ad16d5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $877f77819ad16d5e$var$load("58kAD"),
    $877f77819ad16d5e$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});

parcelRegister("fG32j", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $6wbAc = parcelRequire("6wbAc");

function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
        (0, $6wbAc.SpaceRestrictionCheckQuery), {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
        (0, $6wbAc.SpaceRestrictionCheckQuery), {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        isSpaceNotFound = false;
        isSpaceRestricted = false;
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("5JIjn"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jVylI = parcelRequire("jVylI");


var $9wGTI = parcelRequire("9wGTI");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_bfhki8nm",
            __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("5JIjn", function(module, exports) {

let $42d3870d6cb61948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42d3870d6cb61948$var$load("3yj56"),
    $42d3870d6cb61948$var$load("6mG00"),
    $42d3870d6cb61948$var$load("kULV9"),
    $42d3870d6cb61948$var$load("f35QR"),
    $42d3870d6cb61948$var$load("eVYW1"),
    $42d3870d6cb61948$var$load("ls0Um"),
    $42d3870d6cb61948$var$load("020xd"),
    $42d3870d6cb61948$var$load("eTBsW"),
    $42d3870d6cb61948$var$load("bYxCZ"),
    $42d3870d6cb61948$var$load("6HBYC"),
    $42d3870d6cb61948$var$load("eDqo1"),
    $42d3870d6cb61948$var$load("lxiFd"),
    $42d3870d6cb61948$var$load("1oiJ6"),
    $42d3870d6cb61948$var$load("huUvS"),
    $42d3870d6cb61948$var$load("6wr18"),
    $42d3870d6cb61948$var$load("ht6hk"),
    $42d3870d6cb61948$var$load("6vhrJ"),
    $42d3870d6cb61948$var$load("ffEVr"),
    $42d3870d6cb61948$var$load("jXx9i"),
    $42d3870d6cb61948$var$load("19QIS"),
    $42d3870d6cb61948$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $42omo.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("4emAV"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("4emAV", function(module, exports) {

let $3149ff0fa49973cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3149ff0fa49973cc$var$load("h3ABO"),
    $3149ff0fa49973cc$var$load("2YffH"),
    $3149ff0fa49973cc$var$load("5UCxV"),
    $3149ff0fa49973cc$var$load("2PePB"),
    $3149ff0fa49973cc$var$load("4yXIN"),
    $3149ff0fa49973cc$var$load("4JQof"),
    $3149ff0fa49973cc$var$load("gNLJV"),
    $3149ff0fa49973cc$var$load("c83ag"),
    $3149ff0fa49973cc$var$load("2F69B"),
    $3149ff0fa49973cc$var$load("jyLCl"),
    $3149ff0fa49973cc$var$load("7Ewqa"),
    $3149ff0fa49973cc$var$load("9swiD"),
    $3149ff0fa49973cc$var$load("e4Jl9"),
    $3149ff0fa49973cc$var$load("in5DP"),
    $3149ff0fa49973cc$var$load("gLGsg"),
    $3149ff0fa49973cc$var$load("dpY3T"),
    $3149ff0fa49973cc$var$load("5Fr9q"),
    $3149ff0fa49973cc$var$load("8VT23"),
    $3149ff0fa49973cc$var$load("fJtJG"),
    $3149ff0fa49973cc$var$load("cUIaj"),
    $3149ff0fa49973cc$var$load("d63le"),
    $3149ff0fa49973cc$var$load("l8GL7"),
    $3149ff0fa49973cc$var$load("lkOIY"),
    $3149ff0fa49973cc$var$load("clQc9"),
    $3149ff0fa49973cc$var$load("8PPsf"),
    $3149ff0fa49973cc$var$load("jwWp5"),
    $3149ff0fa49973cc$var$load("k6h1Q"),
    $3149ff0fa49973cc$var$load("lz6Bt"),
    $3149ff0fa49973cc$var$load("76iIp"),
    $3149ff0fa49973cc$var$load("az9CK"),
    $3149ff0fa49973cc$var$load("ht6hk"),
    $3149ff0fa49973cc$var$load("3w411"),
    $3149ff0fa49973cc$var$load("eY3St"),
    $3149ff0fa49973cc$var$load("bkd4T"),
    $3149ff0fa49973cc$var$load("cyGuT"),
    $3149ff0fa49973cc$var$load("6wr18"),
    $3149ff0fa49973cc$var$load("kjZZD"),
    $3149ff0fa49973cc$var$load("Wowvf"),
    $3149ff0fa49973cc$var$load("ffEVr"),
    $3149ff0fa49973cc$var$load("hhss7"),
    $3149ff0fa49973cc$var$load("daAWB"),
    $3149ff0fa49973cc$var$load("hxjWM"),
    $3149ff0fa49973cc$var$load("avVwC"),
    $3149ff0fa49973cc$var$load("9fieX"),
    $3149ff0fa49973cc$var$load("7HyY8"),
    $3149ff0fa49973cc$var$load("6u1hm"),
    $3149ff0fa49973cc$var$load("3yj56"),
    $3149ff0fa49973cc$var$load("6mG00"),
    $3149ff0fa49973cc$var$load("ba8JR"),
    $3149ff0fa49973cc$var$load("jryxA"),
    $3149ff0fa49973cc$var$load("dWZbK"),
    $3149ff0fa49973cc$var$load("kULV9"),
    $3149ff0fa49973cc$var$load("19QIS"),
    $3149ff0fa49973cc$var$load("kUbUu"),
    $3149ff0fa49973cc$var$load("kBC8C"),
    $3149ff0fa49973cc$var$load("hioRe"),
    $3149ff0fa49973cc$var$load("jTort"),
    $3149ff0fa49973cc$var$load("1Ldmy"),
    $3149ff0fa49973cc$var$load("gq5DC"),
    $3149ff0fa49973cc$var$load("kWSPH"),
    $3149ff0fa49973cc$var$load("d4vRh"),
    $3149ff0fa49973cc$var$load("31Cn4"),
    $3149ff0fa49973cc$var$load("7EorR"),
    $3149ff0fa49973cc$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("fyPYm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $5SaYG = parcelRequire("5SaYG");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $5SaYG.ContentViewedEventQuery),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("5SaYG", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c8189816457a0210$export$4dc4e51ac72e6b33 = (0, $eSUdr.default)`query ContentViewedEventQuery($contentId:ID){content(id:$contentId trigger:"viewed"){nodes{id}}}`;
module.exports["ContentViewedEventQuery"] = $c8189816457a0210$export$4dc4e51ac72e6b33;

});

parcelRegister("3Klda", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $42omo.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("eAduJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0e8fee473144754c$export$5ef003f00c9525a1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wviAQ",
    name: "RestrictedSpace",
    loader: async ()=>(await (parcelRequire("fVpwg"))).RestrictedSpace
});
module.exports["RestrictedSpace"] = $0e8fee473144754c$export$5ef003f00c9525a1;

});

parcelRegister("fVpwg", function(module, exports) {

let $b97ff97d8514b795$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b97ff97d8514b795$var$load("8H48c"),
    $b97ff97d8514b795$var$load("2F69B"),
    $b97ff97d8514b795$var$load("hhss7"),
    $b97ff97d8514b795$var$load("2OcM6")
]).then(()=>parcelRequire('9at9H'));

});


//# sourceMappingURL=ViewPageRouteComponent.080875b5.js.map
